import { Users } from "lucide-react";
import { VEHICLES } from "../data/content";
import { FadeUp, SectionHead, Img } from "./Reveal";
import { useEnquiry } from "./EnquiryContext";

const VehicleCard = ({ v }) => {
  const { openEnquiry } = useEnquiry();
  return (
    <div
      data-testid={`vehicle-card-${v.name.toLowerCase().replace(/\s+/g, "-")}`}
      className="group bg-forest-900/60 border border-gold/10 hover:border-gold/40 transition-colors duration-500 overflow-hidden"
    >
      <div className="relative h-52 overflow-hidden">
        <Img
          src={v.img}
          alt={v.name}
          className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-forest-900 to-transparent" />
      </div>
      <div className="p-6">
        <div className="flex items-center justify-between gap-3">
          <h3 className="font-serif text-xl text-cream">{v.name}</h3>
          <span className="flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.15em] text-gold shrink-0">
            <Users size={12} /> {v.seats}
          </span>
        </div>
        <p className="text-sm text-cream/55 mt-2 leading-relaxed">{v.desc}</p>
        <div className="mt-5 flex items-center justify-between">
          <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-terracotta">
            {v.price}
          </span>
          <button
            data-testid={`vehicle-enquire-${v.name.toLowerCase().replace(/\s+/g, "-")}`}
            onClick={() => openEnquiry({ vehicle: v.name })}
            className="border border-gold/40 text-gold font-mono text-[11px] uppercase tracking-[0.18em] px-5 py-2.5 hover:bg-gold hover:text-forest-950 transition-colors duration-300"
          >
            Enquire Now
          </button>
        </div>
      </div>
    </div>
  );
};

export const Rentals = () => (
  <section id="rentals" data-testid="rentals-section" className="relative py-24 lg:py-36">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="mb-16">
        <SectionHead
          num="05"
          eyebrow="Car & Scooty Rental"
          title="Your Ride. Your Journey."
          copy="Well-maintained vehicles, transparent communication and drivers who know these roads by heart."
        />
      </div>

      <FadeUp>
        <div className="flex items-center gap-4 mb-8">
          <h3 className="font-serif text-xl sm:text-2xl text-cream">Car Rental</h3>
          <span className="h-px flex-1 bg-gold/15" />
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-fog">
            Local · Outstation · Sightseeing · Transfers
          </span>
        </div>
      </FadeUp>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-16">
        {VEHICLES.cars.map((v, i) => (
          <FadeUp key={v.name} delay={i * 0.07}>
            <VehicleCard v={v} />
          </FadeUp>
        ))}
      </div>

      <FadeUp>
        <div className="flex items-center gap-4 mb-8">
          <h3 className="font-serif text-xl sm:text-2xl text-cream">Bike & Scooty Rental</h3>
          <span className="h-px flex-1 bg-gold/15" />
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-fog">
            Explore Madhya Pradesh at your own pace
          </span>
        </div>
      </FadeUp>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {VEHICLES.bikes.map((v, i) => (
          <FadeUp key={v.name} delay={i * 0.07}>
            <VehicleCard v={v} />
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
